import React from "react";
import { Alert, Col, Row, Spinner } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import { useRequest } from "../hooks/useRequest";
import { getGamesUrl } from "../config/api";
import { Game } from "../types/models";
import { PaginatedResponse } from "../types/api";
import GameListItem from "../Common/GameListItem";
import { adminGameUrl } from "./adminGameLinks";

interface RecentGamesProps {
  seasonId: number;
  limit?: number;
}

function ListLoadingView() {
  return (
    <Row className="justify-content-md-center">
      <Col md="auto">
        <Spinner animation="grow" /> Loading...
      </Col>
    </Row>
  );
}

function RecentGames({ seasonId, limit = 5 }: RecentGamesProps) {
  const auth = useAuth();

  const { data: gamesResponse, error: gamesError } = useRequest<
    PaginatedResponse<Game>
  >(getGamesUrl(seasonId), auth.token);

  if (gamesError) {
    return (
      <Alert variant="danger">Error loading games: {gamesError.message}</Alert>
    );
  }

  if (!gamesResponse) {
    return <ListLoadingView />;
  }

  const now = new Date();

  // Most recent first, so the game just played is at the top.
  const recentGames = gamesResponse.data
    .filter((game) => new Date(game.date) < now)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, limit);

  if (recentGames.length === 0) {
    return <p className="text-muted">No recent games.</p>;
  }

  return (
    <div>
      {recentGames.map((game) => (
        <GameListItem
          key={game.id}
          game={game}
          to={adminGameUrl(seasonId, game.id)}
        />
      ))}
    </div>
  );
}

export default RecentGames;
